import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  siteChip: {
    backgroundColor: theme.palette.warning.main,
    '&:focus': {
      backgroundColor: theme.palette.warning.main,
    },
  },
  progressDialog: {
    width: 550,
    height: 290,
  },
  gridPaper: {
    maxHeight: 'calc(100vh - 530px)',
    overflowY: 'auto',
    minHeight: 144,
  },
  filterPaper: {
    maxHeight: 76,
    overflowY: 'auto',
  },
  filterBtn: {
    '&:hover': {
      borderColor: '#000000',
    },
    borderColor: '#000000',
    color: '#000000',
  },
  poweredBy: {
    width: '100%',
    textAlign: 'center',
    fontFamily: theme.font.medium,
    color: theme.palette.grey[500],
    position: 'absolute',
    bottom: '32px',
    '& img': {
      width: '24px',
      marginLeft: props => (props.isOpen ? '49px' : '10px'),
      marginRight: '8px',
      float: 'left',
    },
    '& p': {
      width: '100%',
      position: 'relative',
      fontSize: theme.typography.fontSize,
      letterSpacing: '0.5px',
      marginBottom: '11px',
    },
    '& div': {
      float: 'bottom',
      fontSize: '12px',
      letterSpacing: '0.17px',
      width: '59%',
      textAlign: 'left',
    },
  },
  rerunBtn: {
    opacity: 0.5,
  },
}));
